import { jsx as a, jsxs as I } from "react/jsx-runtime";
import r from "react";
import { styled as c, css as d } from "styled-components";
import { a as u } from "./breakpoints.907eaecd.js";
import { k as C } from "./vendor_rango__tokens.38ee67b0.js";
import { D as S, R as z } from "./Description.be3b00d1.js";
import { a as N, R as _, B } from "./index.b09c00db.js";
import { a as L } from "./index.cff5baaf.js";
import { R as Y, I as j } from "./index.5437e162.js";
const h = c.div.withConfig({
  displayName: "Child",
  componentId: "sc-y8uwib-0"
})(["display:flex;justify-content:flex-end;flex-direction:column-reverse;"]), k = c.div.withConfig({
  displayName: "Host",
  componentId: "sc-y8uwib-1"
})(["display:flex;flex-direction:column;position:fixed;bottom:0;left:0;width:100%;pointer-events:none;padding:0 var(--spacing-3x);box-sizing:border-box;overflow:hidden;", "{div[role='alert']:not(:first-child){margin-bottom:var(--spacing-2x);}}"], h), D = c.div.withConfig({
  displayName: "RangoToast",
  componentId: "sc-y8uwib-2"
})(["position:relative;box-sizing:border-box;display:flex;flex-direction:row;align-items:center;gap:var(--spacing-1_5x);padding-right:var(--spacing-half);padding-left:var(--spacing-1_5x);margin-bottom:var(--spacing-5x);border-radius:var(--border-radius-circular);background-color:var(--elements-bg-color-03);box-shadow:var(--shadow-level-3);width:100%;height:var(--size-9x);pointer-events:initial;visibility:hidden;transform:translateY(100%);transition-property:transform,visibility;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-moderate-01);", "{color:var(--inverse-description-color);}", "{color:inherit;", "{color:var(--inverse-icon-color);}&:hover{", "}}*{color:inherit;}", " ", ""], S, N, L, C, u.md(d`
    max-width: 400px;
    margin-bottom: var(--spacing-3x);
    align-self: flex-end;
    transform: translateY(calc(100% + var(--spacing-3x))) translateX(0%);
  `), ({
  opened: s
}) => s && d`
      visibility: visible;
      transform: translateY(0%) translateX(0%);
      transition-timing-function: var(--curve-productive-entrance);
      transition-duration: var(--duration-moderate-02);

      ${u.md(d`
        transform: translateY(0%) translateX(0%);
      `)}
    `), E = c.div.withConfig({
  displayName: "Content",
  componentId: "sc-y8uwib-3"
})(["padding-top:2px;display:flex;flex-direction:column;flex-grow:1;gap:var(--spacing-half);"]), J = {
  Positive: "positive",
  Negative: "negative"
}, H = {
  positive: "PositiveLine",
  negative: "NegativeLine"
}, M = r.forwardRef(({
  toasters: s,
  timer: l = 4e3,
  ...x
}, p) => {
  const [t, m] = r.useState([]), [y, b] = r.useState([]), [f, g] = r.useState([]);
  r.useEffect(() => {
    T();
  }, [s]), r.useEffect(() => {
    (t == null ? void 0 : t.length) > 0 && t.forEach((i) => {
      R(i);
    });
  }, [t]);
  const v = (i) => {
    const o = t.find(({
      id: e
    }) => e === i);
    w(o.id);
  }, T = () => {
    const i = s.filter(({
      opened: n
    }) => n), o = y.map(({
      id: n
    }) => n), e = i.filter(({
      id: n
    }) => !o.includes(n));
    m(e);
  }, R = (i) => {
    f.find(({
      id: e
    }) => e === i.id) || l > 0 && (g([...f, i]), setTimeout(() => {
      v(i.id);
    }, l));
  }, w = (i) => {
    const o = t.find(({
      id: e
    }) => e === i);
    m((e) => e.filter(({
      id: n
    }) => n !== o.id)), b((e) => [...e, o]), g((e) => e.filter(({
      id: n
    }) => n !== i));
  };
  return /* @__PURE__ */ a(k, { ref: p, children: /* @__PURE__ */ a(h, { children: t.map((i, o) => {
    const e = i.type;
    return /* @__PURE__ */ a(r.Fragment, { children: i.opened && /* @__PURE__ */ I(D, { opened: i.opened, type: i.type, ref: p, role: "alert", id: i.id, "data-testid": "rango-toast", "data-rango-component": "rango-toast", "data-is-rango": !0, ...x, children: [
      /* @__PURE__ */ a(Y, { type: e, size: j.SM, icon: H[i.type] }),
      /* @__PURE__ */ a(E, { children: /* @__PURE__ */ a(z, { children: i.children }) }),
      /* @__PURE__ */ a(_, { onClick: () => v(i.id), size: B.SM, icon: "CloseLine", "aria-label": i.buttonIconAriaLabel })
    ] }, o) }, o);
  }) }) });
});
M.displayName = "RangoToast";
export {
  M as R,
  J as T
};
